/**
 * Опции селектора языка отчёта — из каталога `ANALYSIS_LANGUAGES`, а не из
 * рукописных копий на каждом экране.
 *
 * Копий было три (создание проекта, настройки проекта, хаб настройки анализа),
 * в двух разных порядках и против двух разных семейств ключей — подпись
 * «скопировали и слегка поправили». Пока значения совпадают, вреда нет; вред
 * начинается на следующем изменении каталога:
 *
 * - убрали код из `TEMPLATE_LANGUAGES` — рукописные селекторы продолжают его
 *   предлагать, PATCH его не отвергает (`settings: z.record(...)`), значение
 *   ложится в `settings_json`, а `parseProjectSettings` падает на
 *   `z.enum(ANALYSIS_LANGUAGES)`, ловит исключение и возвращает `{}` — молча
 *   теряя ВЕСЬ блок настроек проекта, не только язык;
 * - добавили шестой язык — пайплайн его принимает и на нём пишет, а ни один
 *   селектор его не предлагает.
 *
 * Порядок берётся из каталога, поэтому все три экрана перечисляют языки
 * одинаково. Карты подписей — `Record<AnalysisLanguage, string>`: шестой язык в
 * каталоге ломает сборку ЗДЕСЬ, в одном месте, с указанием на недостающий
 * ключ, вместо трёх молча разошедшихся экранов.
 */
import { ANALYSIS_LANGUAGES, type AnalysisLanguage } from '@aica/core';

export interface AnalysisLanguageOption {
  value: AnalysisLanguage;
  label: string;
}

/** Семейство `settings:*` — настройки проекта и хаб настройки анализа. */
const SETTINGS_LABEL_KEYS: Record<AnalysisLanguage, string> = {
  auto: 'settings:languageAuto',
  en: 'settings:english',
  ru: 'settings:russian',
  uk: 'settings:ukrainian',
  es: 'settings:spanish',
};

/** Семейство `projects.*` — форма создания проекта. */
const PROJECTS_LABEL_KEYS: Record<AnalysisLanguage, string> = {
  auto: 'projects.languageAuto',
  en: 'projects.english',
  ru: 'projects.russian',
  uk: 'projects.ukrainian',
  es: 'projects.spanish',
};

export function buildAnalysisLanguageOptions(
  t: (key: string) => string,
  family: 'settings' | 'projects' = 'settings'
): AnalysisLanguageOption[] {
  const keys = family === 'projects' ? PROJECTS_LABEL_KEYS : SETTINGS_LABEL_KEYS;
  return ANALYSIS_LANGUAGES.map((value) => ({ value, label: t(keys[value]) }));
}
